import { useState, useMemo } from 'react';

function useInputText(ref, onChange) {
    const [text, setText] = useState('');
    const onChangeText = useMemo(() => {
        let oldText = null;
        return (newText, evt) => {
            setText(newText);
            if (oldText !== newText) {
                oldText = newText;
                onChange === null || onChange === void 0 ? void 0 : onChange(newText, evt);
            }
        };
    }, [onChange]);
    return {
        text,
        onChangeText,
    };
}

export { useInputText as default };
